import React from 'react'
import PropTypes from 'prop-types';

export function UiFooterWr(props) {
    return (
        <>
            <footer className="sb-footer">
                {props.children}
            </footer>

        </>
    )
}
export function UiFooterTop(props) {
    return (
        <>
            <div className="sb-footer-top"></div>

        </>
    )
}
export function UiFooterLeftCol(props) {
    return (
        <>
            <div className='sb-footer__left-col'>
                {props.children}
            </div>

        </>
    )
}
export function UiFooterEmailSubscribe(props) {
    return (
        <>
            <div className='sb-footer__email-subscribe'>
                {props.children}
            </div>

        </>
    )
}
export function UiFooterContacts(props) {
    return (
        <>
            <div className='sb-footer__contacts '>
                <div className='sb-footer__email'>
                    <label>Email us</label>
                    <span>{props.email}</span>
                </div>
                <div className='sb-footer__call'>
                    <label>Call us</label>
                    <span>{props.tel}</span>
                </div>
            </div>

        </>
    )
}
export function UiFooterSocialMedia(props) {
    return (
        <>
            <div className='sb-footer__social-media mt-4'>
                {props.children}
            </div>

        </>
    )
}
export function UiFooterCopyRights(props) {
    return (
        <>
            <div className='sb-footer__copyrights mt-4'>
                <span>Copyright © 2022 Strata all rights reserved.</span>
            </div>

        </>
    )
}
export function UiFooterNavWr(props) {
    return (
        <>
            <div className='sb-footer-menu'>
                {props.children}
            </div>

        </>
    )
}
export function UiFooterNavTitle(props) {
    return (
        <>
            <h4>{props.title}</h4>
        </>
    )
}

export function UiFooterNavItem(props) {
    return (
        <>
            <a onClick={props.action}>{props.item}</a>
        </>
    )
}

UiFooterContacts.propTypes = {
    email: PropTypes.string,
    tel: PropTypes.string
};
UiFooterNavTitle.propTypes = {
    title: PropTypes.string
};
UiFooterNavItem.propTypes = {
    action: PropTypes.func
};
